"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var unicode_1 = require("../../../utils/unicode");
var InputHelper_1 = require("./InputHelper");
var OptionsGroup_1 = require("./OptionsGroup");
var InternalInput_1 = require("./InternalInput");
/**
 * OUI checkbox group component.
 *
 * @oui-component CheckBoxGroup
 */
var CheckBoxGroup = function (_a) {
    var value = _a.value, defaultValue = _a.defaultValue, fieldName = _a.fieldName, onSelectionChange = _a.onSelectionChange, onBlur = _a.onBlur, options = _a.options, disabled = _a.disabled, focusable = _a.focusable, direction = _a.direction, testId = _a.testId;
    return (React.createElement(OptionsGroup_1.OptionsGroupContainer, { direction: direction, testId: testId },
        React.createElement(InputHelper_1.default, { disabled: disabled, value: value, defaultValue: defaultValue, onChange: onSelectionChange, onBlur: onBlur, fieldName: fieldName }, function (helper) {
            var valueSet = new Set(helper.value || []);
            var mappedOnChange = function (evt) {
                var _a = evt.target, val = _a.value, checked = _a.checked, attributes = _a.attributes;
                var ariaDisabled = attributes.getNamedItem("aria-disabled");
                var isDisabled = (ariaDisabled && ariaDisabled.value === "true");
                if (checked !== valueSet.has(val) && isDisabled !== true) {
                    var copy = new Set(valueSet);
                    if (checked) {
                        copy.add(val);
                    }
                    else {
                        copy.delete(val);
                    }
                    helper.onChange(Array.from(copy));
                }
            };
            var optionElements = options.map(function (option) {
                var optionName = (helper.fieldId || "oui-checkbox") + "-" + option.value;
                var actionableProps = {
                    focusable: focusable,
                    from: "input",
                    name: optionName,
                    id: optionName,
                    type: "checkbox",
                    className: "oui-checkbox oui-react-checkbox",
                    disabled: option.disabled || disabled,
                    checked: valueSet.has(String(option.value)),
                    value: option.value,
                    onChange: mappedOnChange,
                    onBlur: helper.onBlur,
                    "data-test-id": option.value
                };
                return (React.createElement("div", { key: option.label + "-" + option.value, className: "oui-margin-small-bottom oui-form-field oui-react-form-field" },
                    React.createElement(InternalInput_1.default, __assign({}, actionableProps)),
                    unicode_1.nonBreakingSpace,
                    React.createElement(OptionsGroup_1.OptionLabel, { option: option, htmlFor: optionName, disabled: disabled })));
            });
            return React.createElement(React.Fragment, null, optionElements);
        })));
};
exports.default = CheckBoxGroup;
//# sourceMappingURL=CheckBoxGroup.js.map